import * as React from 'react'
import { styled } from '../styled-components'

interface IProps {
  children?: React.ReactNode
  checked: boolean
  className?: string
  onChange?: (value: boolean) => void
  small?: boolean
}

export const CheckboxControl = (props: IProps) => {
  const { children, checked, className, onChange, small } = props
  return (<Container className={className} onClick={() => onChange && onChange(!checked)}>
    <Box {...{checked, small}} />
    {children}
  </Container>)
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`

const Box = styled.div<{ checked?: boolean, small?: boolean }>`
  flex: 0 0 auto;
  margin-right: 15px;
  border-radius: 4px;
  width: ${props => props.small ? '16px' : '22px'};
  height: ${props => props.small ? '16px' : '22px'};
  background: ${props => props.checked ? props.theme.primaryColor : props.theme.checkboxBackgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background 0.3s ease-out;
  &:after {
    display: block;
    content: '';
    width: ${props => props.checked ? (props.small ? '8px' : '12px') : '0'};
    height: ${props => props.checked ? (props.small ? '8px' : '12px') : '0'};
    border-radius: 50%;
    background: white;
    transition: all 0.1s ease-out;
  }
`
